const Style = {

  // ── Page header ───────────────────────────────────────────────────────────────
  pageTitle:        'text-2xl font-bold text-gray-900 m-0',
  pageSubtitle:     'text-gray-500 text-sm mt-1 mb-5',
  topBar:           'flex justify-between items-center mb-4 gap-3',

  // ── Search ────────────────────────────────────────────────────────────────────
  searchWrap:       'relative w-80 shrink-0',
  searchIcon:       'absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none flex',
  searchInput:      'w-full pl-[38px] pr-3 h-[38px] border border-gray-200 rounded-lg text-sm text-gray-700 outline-none box-border focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1',

  // ── Filter chips bar ──────────────────────────────────────────────────────────
  chipsBar:         'flex items-center gap-2 flex-wrap flex-1',
  clearAllBtn:      'bg-transparent border-none py-1.5 px-1 text-sm text-gray-500 cursor-pointer underline font-normal',

  // ── FilterChip ────────────────────────────────────────────────────────────────
  chipWrap:         'relative',
  chipBase:         'inline-flex items-center gap-1.5 py-1.5 px-3 rounded-lg cursor-pointer text-sm font-medium whitespace-nowrap border transition-colors',
  chipActive:       'border-blue-600 bg-blue-50 text-blue-600',
  chipInactive:     'border-gray-200 bg-white text-gray-700',
  chipDropdown:     'absolute top-[calc(100%+6px)] left-0 z-[200] bg-white border border-gray-200 rounded-xl shadow-[0_4px_16px_rgba(0,0,0,0.08)] min-w-[200px]',

  // ── Dropdown shared ───────────────────────────────────────────────────────────
  dropdownPad:      'p-4',
  dropdownPadWide:  'p-4 w-60',
  dropdownLabel:    'text-[11px] font-semibold text-gray-500 uppercase tracking-[0.06em] mb-2.5',
  dropdownChips:    'flex gap-1.5 flex-wrap',

  // ── License tier pill buttons ─────────────────────────────────────────────────
  tierBtnBase:      'py-1 px-3.5 rounded-full text-[13px] font-medium cursor-pointer border transition-colors',
  tierBtnActive:    'border-blue-600 bg-blue-50 text-blue-600',
  tierBtnInactive:  'border-gray-200 bg-gray-100 text-gray-700',

  // ── Practice areas dropdown ────────────────────────────────────────────────────
  practiceSearch:   'w-full h-8 px-2.5 mb-2 border border-gray-200 rounded text-[13px] text-gray-700 outline-none box-border',
  practiceList:     'max-h-[220px] overflow-y-auto flex flex-col gap-1',
  practiceEmpty:    'text-[13px] text-gray-400 py-1',
  practiceItem:     'flex items-center gap-2 py-1 cursor-pointer text-[13px] text-gray-700',
  practiceCheckbox: 'cursor-pointer accent-blue-600',

  // ── Avg prompts dropdown ───────────────────────────────────────────────────────
  avgOptionsList:   'flex flex-col gap-1',
  avgBtnBase:       'py-1.5 px-3 rounded text-left text-[13px] cursor-pointer border transition-colors',
  avgBtnActive:     'border-blue-600 bg-blue-50 text-blue-600 font-medium',
  avgBtnInactive:   'border-transparent bg-transparent text-gray-700 font-normal',

  // ── Date dropdown ─────────────────────────────────────────────────────────────
  dateCol:          'flex flex-col gap-2',
  dateRow:          'flex items-center gap-2',
  dateFromToLabel:  'text-xs text-gray-400 w-7 shrink-0',
  dateInput:        'w-full h-8 px-2.5 border border-gray-200 rounded text-[13px] text-gray-700 outline-none box-border focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1',

  // ── Table cells (renderCell) ──────────────────────────────────────────────────
  cellName:          'py-3 px-4 font-medium text-gray-900 whitespace-nowrap',
  cellNameLink:      'text-inherit no-underline',
  cellEmail:         'py-3 px-4 text-gray-700',
  cellDate:          'py-3 px-4 whitespace-nowrap',
  cellDateMain:      'text-gray-900',
  cellDateTime:      'text-gray-400 text-xs',
  cellStatus:        'py-3 px-4',
  cellLicense:       'py-3 px-4',
  cellPractice:      'py-3 px-4 min-w-[160px]',
  cellLatestPrompts: 'py-3 px-4 text-gray-700 text-right',
  cellAvgPrompts:    'py-3 px-4 text-center',
  cellActions:       'py-3 px-4 relative',

  // ── Kebab menu ────────────────────────────────────────────────────────────────
  kebabBtn:         'bg-transparent border-none cursor-pointer text-gray-500 text-xl leading-none py-0.5 px-1.5 rounded hover:bg-gray-100',
  kebabMenu:        'absolute right-0 top-full z-[100] bg-white border border-gray-200 rounded-lg shadow-[0_4px_12px_rgba(0,0,0,0.1)] min-w-[140px]',
  kebabItem:        'block w-full py-2 px-4 bg-transparent border-none text-left text-sm cursor-pointer hover:bg-gray-50',
  kebabItemNormal:  'text-gray-700',
  kebabItemDanger:  'text-red-600',

};

export default Style;
